module.exports = __webpack_public_path__ + "static/media/shirts7.a676550d.webp";